import App from "base-shell/lib";
import LiffProvider from "providers/Liff";
import { Component } from "react";
import ReactGA from "react-ga4";

import { liffId, stage } from "config/const";
import _config from "./config";

import { gaTrackingId, imagTrackingId } from "config/const";
import "styles/index.css";
import "styles/quill.css";

ReactGA.initialize([
  { trackingId: gaTrackingId },
  { trackingId: imagTrackingId },
]);

export default class Demo extends Component {
  render() {
    return (
      <LiffProvider
        liffId={liffId}
        mock={stage === "local" ? require("config/mock").liff : undefined}
      >
        <App config={_config} />
      </LiffProvider>
    );
  }
}
